import { Injectable } from "@angular/core";
import { DataService } from "../CommonService/data.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class GTCRequisitionservice {

    constructor(private _data: DataService) {

    }

    saveOrUpdateGTCRequest(GTCFormData: any,  param: any): any {
        let url = "TaxGTC/SaveGTCData";
        if (param != null) {
            url += '/' + param;
        }
        return this._data.create(url, GTCFormData)
    }

    ExportToExcelClauses(caluseDetails: any): any {
        let url = "TaxGTC/ExportToExcelClauses";
        return this._data.create(url, caluseDetails)
    }

    sendBackToTQOrET(GTCFormData: any): any {
        let url = "TaxGTC/SendOrTQAndET";
        return this._data.create(url, GTCFormData)
    }
    GetGTCRequest(GTCRequestId: any,value:any): Observable<any> {
        return this._data.get("TaxGTC/GetGTCRequestById", GTCRequestId,value)
    }
    GetGTCRequestByIdForTQLeader(GTCRequestId: any): Observable<any> {
        return this._data.get("TaxGTC/GetGTCRequestByIdForTQLeader", GTCRequestId)
    }

    GetAllFDetailsOfGTCForm(GTCFormData: any,  param: any): any {
        let url = "TaxGTC/GetGTCAllRequests";
        if (param != null) {
            url += '/' + param;
        }
        return this._data.create(url, GTCFormData)
    }

    GetSAFData(GTCFormData: any){
        let url = "TaxGTC/GetSAFData";
        return this._data.create(url, GTCFormData)
    }

    SaveUserAppDetails(GTCFormData: any): any {
        let url = "TaxGTC/SaveUserAppDetails";
        return this._data.create(url, GTCFormData)
    }

    ChangeApprovalStatus = (data: any): any => {
        return this._data.update('TaxGTC/ChangeApprovalStatus', data, null);
    }




    RemoveUserAccess(GTCFormData: any,param: any): any {
        let url = "TaxGTC/RemoveUserAccess";
        if (param != null) {
            url += '/' + param;
            
        }
        return this._data.create(url, GTCFormData)
    }
}